import React from "react";

import styled from "@emotion/styled";

const StyledContainer = styled("div", {
    shouldForwardProp: (prop) =>
        !["desktopFullWidth", "noPadding", "slim", "ultraSlim"].includes(
            prop
        ),
})`
    margin: 0 auto;
    padding: 20px;

    @media screen and (min-width: 1024px) {
        max-width: 1024px !important;
    }

    ${({ desktopFullWidth }) =>
        desktopFullWidth &&
        `
        @media screen and (min-width: 1024px) {
            max-width: 100% !important;
        }
    `}

    ${({ noPadding }) => noPadding && `padding: 0;`}

    ${({ slim }) =>
        slim &&
        `
        max-width: 768px !important;

        @media screen and (min-width: 1024px) {
            max-width: 768px !important;
        }
    `}

    ${({ ultraSlim }) =>
        ultraSlim &&
        `
        max-width: 512px !important;

        @media screen and (min-width: 1024px) {
            max-width: 512px !important;
        }
    `}
`;

const Container = ({
    children,
    desktopFullWidth = false,
    className = "",
    noPadding = false,
    slim = false,
    ultraSlim = false,
    style = {},
    onClick = undefined,
    ...props
}) => {
    return (
        <StyledContainer
            style={style}
            className={className}
            desktopFullWidth={desktopFullWidth}
            noPadding={noPadding}
            slim={slim}
            ultraSlim={ultraSlim}
            onClick={onClick}
            {...props}
        >
            {children}
        </StyledContainer>
    );
};

export default Container;
